import React, { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";  
import { loginRequest } from "./authConfig";
import { useAppContext } from "./context/appcontext";
import localforage from "localforage";

const AuthHandler = () => {
    const { instance } = useMsal();
    const {authChecked, setAuthChecked, setLoggedinuser } = useAppContext();
    const [errorMessage, setErrorMessage] = useState("");
    const hasRun = useRef(false);
    const [profileImage, setProfileImage] = useState(null);
    useEffect(() => {
        
        if (hasRun.current) return;
        hasRun.current = true;

        const authenticateUser = async () => {
            try {
                
               await instance.initialize();  
                const response = await instance.handleRedirectPromise();

                if (response) {
                    instance.setActiveAccount(response.account);
                } else {
                    const accounts = instance.getAllAccounts();
                    if (accounts.length > 0) {
                        instance.setActiveAccount(accounts[0]);
                    } else {
                         
                        instance.loginRedirect();
                        return;
                    }
                }

              
                const account = instance.getActiveAccount();
                if (!account) {
                    instance.loginRedirect();  
                    return;
                }
                // EARLY background fetch of UsersJson
                (async () => {
                    try {
                        const bgToken = await instance.acquireTokenSilent({
                            scopes: loginRequest.scopes,
                            account
                        });

                        const endpoint = `${process.env.REACT_APP_API_URL}/User/GetUsersJson?id=${account.localAccountId}`;
                        
                        console.log("🔄 Early Fetch: UsersJson...");
                        
                        axios
                            .get(endpoint, {
                                headers: {
                                    Authorization: `Bearer ${bgToken.accessToken}`
                                }
                            })
                            .then(async (res) => {
                                await localforage.setItem("UsersJson", res.data);
                                console.log("✅ Early UsersJson stored!");
                            })
                            .catch((e) => {
                                console.error("❌ Early UsersJson Fetch Failed", e);
                            });
                    } catch (e) {
                        console.error("Token fetch failed for early UsersJson", e);
                    }
                })();

                let tokenResponse;
                try {
                    tokenResponse = await instance.acquireTokenSilent({
                        scopes: loginRequest.scopes,
                        account
                    });
                } catch (error) {
                    console.warn("Silent token acquisition failed, attempting redirect login", error);
                    instance.loginRedirect();
                    return;
                }

                debugger
                const tokenResponseGetUser = await instance.acquireTokenSilent({
                    scopes: ["User.Read"],
                    account
                })
                const accessToken = tokenResponse.accessToken;
                const accessTokenUser = tokenResponseGetUser.accessToken;
               const graphResponse = await axios.get("https://graph.microsoft.com/v1.0/me?$select=id,displayName,mail,companyName,jobTitle,createdOn,createdBy,mobilePhone,givenName,officeLocation,preferredLanguage,surname,userPrincipalName", {
                headers: {
                    Authorization: `Bearer ${accessTokenUser}`
                }
                });
                const graphUser = graphResponse.data;
                
                const mappedUser = {
                id:graphUser.id,
                businessPhones: graphUser.businessPhones ?? [],
                displayName: graphUser.displayName,
                givenName: graphUser.givenName ?? "",
                jobTitle: graphUser.jobTitle ?? "",
                companyName: graphUser.companyName ?? "",
                mail: graphUser.mail,
                mobilePhone: graphUser.mobilePhone ?? "",
                officeLocation: graphUser.officeLocation ?? "",
                preferredLanguage: graphUser.preferredLanguage ?? "",
                surname: graphUser.surname ?? "",
                userPrincipalName: graphUser.userPrincipalName,
                userid: graphUser.id,

                department: null,
                Status: "Active",
                CreatedBy: "",
                ModifiedBy: "",
                CompanyId: "00000000-0000-0000-0000-000000000000",
                profileImage: null,
                roleId: [],
                roles: null,
                token: accessToken
                };
              
                axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
                localStorage.setItem('access_token', tokenResponse.accessToken);

                 
                try{     
                    debugger
                    const apiUrl = process.env.REACT_APP_API_URL + '/auth/login'; 
                    const dbResponse = await axios.post(apiUrl, mappedUser, {
                        headers: { Authorization: `Bearer ${accessToken}` }
                    });

                if (dbResponse.status !== 200) {
                    setErrorMessage("You do not have access to this application.");
                    setTimeout(() => instance.logoutRedirect(), 3000);  
                    return;
                }
                
                let profileImageBase64 = null;
                try {
                    const imageResponse = await axios.get("https://graph.microsoft.com/v1.0/me/photo/$value", {
                        headers: {
                            Authorization: `Bearer ${accessTokenUser}`
                        },
                        responseType: 'blob'
                    });

                    profileImageBase64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.onerror = reject;
                        reader.readAsDataURL(imageResponse.data);
                    });
                } catch (error) {
                    console.error("Failed to fetch profile image:", error);
                    profileImageBase64 = null;
                }

                const userWithImage = {
                    ...dbResponse.data.user,
                    profileImage: profileImageBase64
                };
                
                setAuthChecked(true);
                localStorage.setItem('authChecked', 'true');
                setLoggedinuser(userWithImage);
                localStorage.setItem("loggedinuser", JSON.stringify(userWithImage));

                localStorage.setItem("loggedinuser", JSON.stringify(dbResponse.data.user));

              }catch (error) {
                setErrorMessage(error.response.data);
                setTimeout(() => instance.logoutRedirect(), 3000);
            }
              
            } catch (error) {
                console.error("MSAL authentication failed:", error);
                setErrorMessage("Authentication failed. Redirecting to login...");
                setTimeout(() => instance.logoutRedirect(), 3000);
            }
        };

        authenticateUser();
    }, [instance,setAuthChecked]);

    useEffect(() => {
        const interval = setInterval(async () => {
            console.log("Interval hit .")
            const account = instance.getActiveAccount();
            console.log("Account - " + account);
            if (!account) return;

            try {
                console.log("In try catch we are.");
                const tokenResult = await instance.acquireTokenSilent({
                    scopes: loginRequest.scopes,
                    account
                });
                localStorage.setItem('access_token', tokenResult.accessToken);
                axios.defaults.headers.common["Authorization"] = `Bearer ${tokenResult.accessToken}`;
            } catch (err) {
                console.warn("Token refresh failed. Redirecting to login...");
                instance.loginRedirect();
            }
        }, 50 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);

   
    if (!authChecked) {
        return (
            <div className="container mt-5">
                {errorMessage && (
                    <div className="alert alert-danger text-center" role="alert">
                        {errorMessage}
                    </div>
                )}
              {!errorMessage && ( 
                <div className="spinner-overlay">
               <div className="spinner">
                   <div className="lds-roller">
                       <div></div>
                       <div></div>
                       <div></div>
                       <div></div>
                       <div></div>
                       <div></div>
                       <div></div>
                       <div></div>
                   </div>
                   <div>Validating User...</div>
               </div>
           </div>
            )}
            </div>
        );
    }

    return null;
};

export default AuthHandler;
